// extracted by mini-css-extract-plugin
module.exports = {"container":"WindowedList_container__AzJ8p"};